import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Print({
  color = 'icon.primary',
  strokeWidth = '1.25',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 16 16' {...props}>
      <Path
        d='M5 2.5H11C11.5523 2.5 12 2.94772 12 3.5V6.5H4V3.5C4 2.94772 4.44772 2.5 5 2.5Z'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d={
          'M2.5 6.5H13.5C14.0523 6.5 14.5 6.94772 14.5 7.5V12.5C14.5 13.0523 14.0523 13.5 13.5 13.5H2.5' +
          'C1.94772 13.5 1.5 13.0523 1.5 12.5V7.5C1.5 6.94772 1.94772 6.5 2.5 6.5Z'
        }
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M6 4H10'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M6 5.25H10'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M5.5 9.75H10.5'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Print.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default Print
